import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../core/services/user/user.service';
import { HttpClient } from '@angular/common/http';
import { CollisService } from 'src/app/core/services/collis/collis.service';
import { UserOptions } from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { ColissessionService } from '../../../core/services/colissession/colissession.service';
import { DatePipe } from '@angular/common';
import { data } from 'jquery';
import { RecetteService } from '../../../core/services/recette/recette.service';
import { BagageService } from '../../../core/services/bagage/bagage.service';
import { VoyageService } from '../../../core/services/voyage/voyage.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProfileComponent } from 'src/app/module/account/profile/profile.component';
import { LogService } from '../../../core/services/log/log.service';
import { ImageCacheService } from 'src/app/core/services/image/image-cache.service';

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {

  sessionNumber: any;
  base64: any;
  collis: any;
  picture: any;
  sessiondetail: any;
  name: string;
  depense: any;
  pageheight: any;
  recette: any;
  bagage: any;
  ispopup: boolean;
  pageHeights3: any;
  pageHeights2: any;
  countlogs: any = 0;
  profileImageBase64: string | null = null;
  translateImageBase64: string | null = null;
  englishFlagBase64: string | null = null;
  frenchFlagBase64: string | null = null;


  constructor( private dialog: MatDialog, private router: Router, private translationService: TranslationService, private translate: TranslateService, private sessionservice: ColissessionService, private collisservice: CollisService,
    private userservice: UserService, private http: HttpClient, private datepipe: DatePipe, private recetteservice: RecetteService,
    private bagageservice: BagageService,private logservice: LogService,
    private voyageservice:VoyageService,
    private imageCacheService: ImageCacheService){
      this.ispopup = false;
    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    this.picture = personid[0].profile;
    this.name = personid[0].nom + ' ' + personid[0].prenom;
    // console.log(this.picture);
    if (localStorage.getItem('session') != null && localStorage.getItem('session') != ''){
      this.getsessioninfo(localStorage.getItem('session'));
    }
    this.countlog();
    this.loadProfileImage();
    this.loadHeaderImages();
  }

  loadProfileImage(): void {
    this.imageCacheService
      .getImage('assets/images/profile.jpg')
      .subscribe({
        next: (base64: string) => {
          this.profileImageBase64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading profile image:', error);
          // Fallback to direct path will be used via template binding
        }
      });
  }

  loadHeaderImages(): void {
    // Load translate icon
    this.imageCacheService.getImage('assets/images/translate.png').subscribe({
      next: (base64: string) => {
        this.translateImageBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading translate image:', error);
      }
    });

    // Load English flag
    this.imageCacheService.getImage('assets/images/english.jpg').subscribe({
      next: (base64: string) => {
        this.englishFlagBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading English flag:', error);
      }
    });

    // Load French flag
    this.imageCacheService.getImage('assets/images/french.jpg').subscribe({
      next: (base64: string) => {
        this.frenchFlagBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading French flag:', error);
      }
    });
  }

  viewProfil(): any {

    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    // dialogConfig.position={
    //   right:'110px',
    // };
    dialogConfig.data = {};
    const dialogref = this.dialog.open(ProfileComponent , {
      width: 'auto', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {}
    });
  }

  countlog(): any{
    this.logservice.countlogs().subscribe((data: any)=>{
      this.countlogs = data
    })
  }

  refreshtab(): any{
    const currentUrl = this.router.url;
    // const currentUrl = 'collis/mail';
    // console.log(currentUrl);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
}

  logout(): any{
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('session');
    localStorage.removeItem('authority');
    localStorage.removeItem('lastprint');
    this.router.navigateByUrl('login');
    localStorage.removeItem('voyage');
    localStorage.clear();
  }

  closesession(): any {
    this.getlogo();
    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    const sessionid = '';
    const session = localStorage.getItem('session');

    this.userservice.updateusersession(personid[0].idpersonnel, sessionid, session).subscribe((response: any) => {
      // console.log(response);
      this.getsessioninfoBeforeCloseSession(session);

    },(error: any)=>{
      console.log('update session error ',error);
    });
  }

  changeLanguage(lang: any): any {
    if (lang != undefined && lang !== localStorage.getItem('lang')) {
      this.translationService.changeLanguage(lang, true);
    }
  }

  changeLang(language: string): any{
    this.translate.use(language);
  }

  closetab(): void{
    window.close();
  }

  async print(session: any): Promise<any> {
    // console.log(session);
    const page = 0; const size = 10000;
    await this.collisservice.getallcollisinSession(session, page, size).subscribe((collis: any) => {
      // console.log('collis', collis.content);
      this.collis = collis.content;
      // console.log("collis", this.collis);

      let doc: any;
      const datas = collis.content;
      // console.log('length ', data);
      let heightdoc = 0.3 * (datas?.length - 2);


      if (this.collis?.length < 4){
          heightdoc = 0;
        }
        // console.log('height doc ', heightdoc);
        // var doc = new jsPDF('l', 'in', [(3+heightdoc), 8.25]) as jsPDFWithPlugin;
      // doc = new jsPDF('p', 'in', [(8.27),(11.69)]) as jsPDFWithPlugin;
      doc = new jsPDF(this.collis?.length > 23 ? 'p' : 'l', 'in', [( 3 + heightdoc), 8.25]) as jsPDFWithPlugin;

      const content: any = [];
      for (let i = 0; i < datas.length; i++){
        const rowdata = [];
        // console.log('Content', data[i]);
        for (let index = 0; index < datas.length; index++) {
            rowdata.push((i + 1), datas[i].ticket, datas[i].descriptioncollis, datas[i].sender.name, datas[i].receiver[0].name, datas[i].receiver[0].primarynumber, datas[i].tarif, this.datepipe.transform(datas[i].creationdate, 'dd-MM-yyyy HH:mm:ss'));
          }
        content.push(rowdata);
      }

      doc.setFontSize(12);
      doc.setFont('Arial', 'bold');
      doc.text('GENERAL EXPRESS VOYAGES', 3, 0.27);
      // doc.text('GENERAL EXPRESS VOYAGES', data.settings.margin.left, 22);
      doc.setFontSize(12);
      doc.setFont('Arial', 'bold');
      doc.text('RAPPORT DE SESSION #' + this.sessiondetail?.idsessiion + '/' + this.sessiondetail?.sessionCount, 0.3, 0.4);
      doc.setFontSize(12);
      // doc.setTextColor(100);
      doc.setFont('Arial', 'bold');
      doc.text('Agent:  ' + this.name, 0.6, 0.6);
      doc.text('S/N:  ' + this.sessiondetail?.idsessiion, 0.6, 0.8);
      doc.text('Montant:  ' + this.sessiondetail?.sessionAmount + ' FCFA', 0.6, 1);
      doc.text('Date Ouverture S/N:  ' + this.datepipe.transform(this.sessiondetail?.creationDate, 'yyyy-MM-dd HH:mm:ss') , 3, 0.8);
      doc.text('Date Fermeture S/N:  ' + this.datepipe.transform(this.sessiondetail?.closingDate, 'yyyy-MM-dd HH:mm:ss') , 3, 1);
      doc.text('Date:  ' + this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss') , 3, 0.6);
      // doc.text('Motoboy:  ' + this.bordereauinfo.motoboy.nommb, 5, 0.72);

      const base64Img = this.base64;

      if (base64Img) {
        doc.addImage(this.base64, 'JPEG', 6.7, 0, 1, 1);
      }

      doc.autoTable({
        head: [['#', 'N°', 'Nature du Colis', 'Expéditeur', 'Destinataire', 'Telephone', 'Prix', 'Date']],
        body: content,
        showHead: 'firstPage',
        startY: 1.05,
        pageBreak: 'auto',
        rowPageBreak: 'auto',
        theme: 'plain',
        headStyles: {
          fontStyle: 'bold',
          font: 'Arial',
          fontSize: 12,
          fillColor: '#ffffff',
          lineWidth: 0.01,
          lineColor: '#000000',
        },
        styles: {
          overflow: 'ellipsize',
          fontSize: 10,
          font: 'Arial',
          lineWidth: 0.01,
          lineColor: '#000000',
          textColor : '#000000',
        },
        didDrawPage: (data: any) => {
          // Header

          doc.setFontSize(20);
          doc.setTextColor(40);
          // const base64Img = 'data:image/jpeg;base64,' + btoa('../../../../assets/images/logogen.jpg');
          // const base64Img = this.base64;

          // if (base64Img) {
          //   doc.addImage(this.base64, 'JPEG', 6.7, 0, 1, 1);
          // }
          // doc.text('Report', data.settings.margin.left + 15, 22)

          // Footer
          doc.setFontSize(11);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          const pageCount = doc.internal.getNumberOfPages();
          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          // doc.text('Visa Agent', data.settings.margin.left, pageHeight);
          if (doc.internal.getCurrentPageInfo().pageNumber == pageCount) {
            doc.text('TOTAL MONTANT: ' + this.sessiondetail?.sessionAmount + ' FCFA', data.settings.margin.right + 2, (pageHeight - 0.7), {align: 'center'});
            doc.setFontSize(10);
            doc.text('Visa Agent', data.settings.margin.right + 2, (pageHeight - 0.5), {align: 'center'});
            doc.text('Visa du Chef', data.settings.margin.right + 4.2, (pageHeight - 0.5),{align: 'center'});
          }
        },
        drawRow: (row: any) => {
          if (row.index > 0 && row.index % 23 === 0) {
             doc.autoTableAddPage();
             doc = new jsPDF(this.collis?.length > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
           }
         }
      });
      // doc.save('table.pdf');

      doc.autoPrint();
      //This is a key for printing
      doc.output('dataurlnewwindow');
      //end print
    });
    setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      localStorage.removeItem('section');
      this.router.navigateByUrl('login');
      localStorage.removeItem('session');
      }, 300);
  }


  async print2(session: any): Promise<any> {
    // console.log(datas);
    const page = 0; const size = 1000;
    await this.collisservice.getallcollisinSession(session, page, size).subscribe((collis: any) => {
      // console.log("collis", collis.content);
      this.collis = collis.content;
      // console.log("collis", this.collis);

      let doc: any;
      // collis
      const data = collis.content;
      this.bagageservice.getallbagageinSession(session, page, size).subscribe((bagage: any) => {
        this.bagage = bagage.content;

        this.recetteservice.getallrecetteinSession(session, page, size).subscribe((recette: any) => {
          this.recette = recette.content;

          this.recetteservice.getalldepenseinSession(session, page, size).subscribe((depense: any) => {
            this.depense = depense.content;

            const length = this.collis?.length > this.bagage?.length ? this.collis?.length : this.bagage?.length;
            let heightdoc = 0.3 * ((length) - 2);


            if ((this.collis?.length) < 4){
                heightdoc = 0;
            }
            // console.log('height doc ', heightdoc);
            // doc = new jsPDF((length) > 23 ? 'p' : 'l', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
            doc = new jsPDF('l', 'in',[6, 8.50]) as jsPDFWithPlugin;

            // colis data
            const content: any = [];
            let totalcolis = 0;
            for (let i = 0; i < data.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
                for (let index = 0; index < data.length; index++) {
                  rowdata.push((i+1), data[i].ticket,data[i].descriptioncollis, data[i].sender.name, data[i].receiver[0].name, data[i].receiver[0].primarynumber,data[i].tarif,this.datepipe.transform(data[i].creationdate, 'dd-MM-yyyy HH:mm:ss'));
                  totalcolis = totalcolis + data[i].tarif;
                }
                content.push(rowdata);
            }

          // bagage data
            const contentbagage: any = [];
            let totalbagage = 0;
            for (let i = 0; i < this.bagage.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
              for (let index = 0; index < this.bagage.length; index++) {
                  rowdata.push(( i + 1), this.bagage[i].idbagage, this.bagage[i].description, this.bagage[i].sendername, this.bagage[i].primaryphone, this.bagage[i].tarif, this.datepipe.transform(this.bagage[i].creationDate, 'dd-MM-yyyy HH:mm:ss'));
                  totalbagage = totalbagage + this.bagage[i].tarif;
                }
              contentbagage.push(rowdata);
            }

            // recette data
            const contentrecette: any = [];
            let totalrecette = 0;
            for (let i = 0; i < this.recette.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
              for (let index = 0; index < this.recette.length; index++) {
                  rowdata.push(( i + 1), this.recette[i].idrecette, this.recette[i].description, this.recette[i].sendername, this.recette[i].primarynumber, this.recette[i].tarif, this.datepipe.transform(this.recette[i].creationDate, 'dd-MM-yyyy HH:mm:ss'));
                  totalrecette = totalrecette + this.recette[i].tarif;
                }
              contentrecette.push(rowdata);
            }

            // depense data
            const contentdepense: any = [];
            let totaldepense = 0;
            for (let i = 0; i < this.depense.length; i++){
              const rowdata = [];
              // console.log('Content', data[i]);
              for (let index = 0; index < this.depense.length; index++) {
                  rowdata.push(( i + 1), this.depense[i].idrecette, this.depense[i].description, this.depense[i].sendername, this.depense[i].primarynumber, this.depense[i].tarif, this.datepipe.transform(this.depense[i].creationDate, 'dd-MM-yyyy HH:mm:ss'));
                  totaldepense = Number(totaldepense) + Number(this.depense[i].tarif);
                }
              contentdepense.push(rowdata);
            }

            doc.setFontSize(13);
            doc.setFont("Arial", "bold");
            doc.text("GENERAL EXPRESS VOYAGES", 2.5, 0.27);
            // doc.text('GENERAL EXPRESS VOYAGES', data.settings.margin.left, 22);
            doc.setFontSize(11);
            doc.text("RAPPORT DE FIN DE SESSION" ,2.7, 0.5 );
            doc.setFontSize(9);
            doc.text("Agent:  " + this.name, 1.5, 0.65);
            doc.text("S/N:  " +
            this.sessiondetail?.idsessiion +
            "  N° " +
            this.sessiondetail.sessionCount,
            1.5, 0.83);
            doc.text(
              "Montant:  " + this.sessiondetail?.sessionAmount + " FCFA",
              1.5,
              1
            );
            doc.text(
              "Date d\'impression:  " +
                this.datepipe.transform(
                  new Date(),
                  "dd-MM-yyyy HH:mm:ss"
                ),
                5,
              0.65
            );
            doc.text(
              "Date D\'Ouverture S/N:  " +
                this.datepipe.transform(
                  this.sessiondetail?.creationDate,
                  "dd-MM-yyyy HH:mm:ss"
                ),
              5,
              0.83
            );
            doc.text(
              "Date De Fermeture S/N:  " +
                this.datepipe.transform(
                  this.sessiondetail?.closingDate,
                  "dd-MM-yyyy HH:mm:ss"
                ),
                5,
              1
            );

            // doc.text('Motoboy:  ' + this.bordereauinfo.motoboy.nommb, 5, 0.72);

            const base64Img = this.base64;

            if (base64Img) {
              doc.addImage(this.base64, "JPEG", 0.1, 0, 1, 1);
            }


            doc.autoTable({
              head: [['#', 'N°', 'Nature du Colis', 'Expéditeur', 'Destinataire', 'Telephone', 'Prix', 'Date']],
              body: content,
              showHead: 'firstPage',
              startY: 1.1,
              pageBreak: 'auto',
              rowPageBreak: 'auto',
              horizontalPageBreak: false,
              avoidPageSplit: true,
              theme: 'plain',
              headStyles: {
                fontSize: 12,
                fillColor: '#ffffff',
                fontStyle: 'bold',
                font: 'Arial',
                lineWidth: 0.01,
                lineColor: '#000000',
              },
              styles: {
                overflow: 'ellipsize',
                fontSize: 10,
                font: 'Arial',
                lineWidth: 0.01,
                lineColor: '#000000',
                textColor : '#000000',
              },
              didDrawPage: (data: any) => {
                // // Header

                // // Footer
                // doc.setFontSize(11);
              },
              drawRow: (row: any) => {
                if (row.index > 0 && row.index % 23 === 0) {
                  doc.autoTableAddPage();
                  doc = new jsPDF((this.collis?.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                }
              }
            });

            this.pageheight = doc.autoTableEndPosY() + 1.01;
            const pageHeightsc = doc.autoTableEndPosY() + 1;

            doc.setFontSize(11);
            doc.text('TOTAL COLIS: ' + (totalcolis / this.collis.length) + ' FCFA', 2, (pageHeightsc - 0.7), {align: 'center'});
                  // doc.setFontSize(10);
                  // doc.text('Visa Agent', 2, (pageHeightsc - 0.5), {align: 'center'});
                  // doc.text(datas.name, 2, (pageHeightsc - 0.2), {align: 'center'});
                  // doc.text('Visa du Chef', 4.2, (pageHeightsc - 0.5), {align: 'center'});

          // bagage table

            if (this.bagage.length > 0) {
              doc.autoTable({
                head: [['#', 'N°', 'Description Bagage', 'Expéditeur', 'Telephone', 'Prix', 'Date']],
                body: contentbagage,
                showHead: 'firstPage',
                startY: this.pageheight,
                pageBreak: 'auto',
                rowPageBreak: 'auto',
                horizontalPageBreak: false,
                theme: 'plain',
                avoidPageSplit: true,
                headStyles: {
                  fontSize: 12,
                  fillColor: '#ffffff',
                  fontStyle: 'bold',
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                },
                styles: {
                  overflow: 'ellipsize',
                  fontSize: 10,
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                  textColor : '#000000',
                },
                didDrawPage: (data: any) => {
                  // // Header
                },
                drawRow: (row: any) => {
                  if (row.index > 0 && row.index % 23 === 0) {
                    doc.autoTableAddPage();
                    doc = new jsPDF((this.bagage.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                  }
                }
              });

              this.pageheight = doc.autoTableEndPosY() + 1.01;
              const pageHeights2 = doc.autoTableEndPosY() + 1;

              doc.text('TOTAL BAGAGE: ' + (totalbagage / this.bagage.length) + ' FCFA', 2, (pageHeights2 - 0.7), {align: 'center'});
            }

            // recette table

            if (this.recette.length > 0) {
              doc.autoTable({
                head: [['#', 'N°', 'Description Recette', 'Client', 'Telephone', 'Prix', 'Date']],
                body: contentrecette,
                showHead: 'firstPage',
                startY: this.pageheight,
                pageBreak: 'auto',
                rowPageBreak: 'auto',
                horizontalPageBreak: false,
                avoidPageSplit: true,
                theme: 'plain',
                headStyles: {
                  fontSize: 12,
                  fillColor: '#ffffff',
                  fontStyle: 'bold',
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                },
                styles: {
                  overflow: 'ellipsize',
                  fontSize: 10,
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                  textColor : '#000000',
                },
                didDrawPage: (data: any) => {
                  // Header
                },
                drawRow: (row: any) => {
                  if (row.index > 0 && row.index % 23 === 0) {
                    doc.autoTableAddPage();
                    doc = new jsPDF((this.recette.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                  }
                }
              });
              const pageCount = doc.internal.getNumberOfPages();
              const pageSize = doc.internal.pageSize;
              const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
              this.pageheight = doc.autoTableEndPosY() + 1.01;
              const pageHeights = doc.autoTableEndPosY() + 1;

              doc.setFontSize(11);
              doc.text('TOTAL RECETTE: ' + (totalrecette / this.recette.length) + ' FCFA', 2, (pageHeights - 0.7), {align: 'center'});
            }

            // depense table

            if (this.depense.length > 0) {
              doc.autoTable({
                head: [['#', 'N°', 'Description Depense', 'Client', 'Telephone', 'montant', 'Date']],
                body: contentdepense,
                showHead: 'firstPage',
                startY: this.pageheight,
                pageBreak: 'auto',
                rowPageBreak: 'auto',
                horizontalPageBreak: false,
                avoidPageSplit: true,
                theme: 'plain',
                headStyles: {
                  fontSize: 12,
                  fillColor: '#ffffff',
                  fontStyle: 'bold',
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                },
                styles: {
                  overflow: 'ellipsize',
                  fontSize: 10,
                  font: 'Arial',
                  lineWidth: 0.01,
                  lineColor: '#000000',
                  textColor : '#000000',
                },
                didDrawPage: (data: any) => {
                  // Header
                },
                drawRow: (row: any) => {
                  if (row.index > 0 && row.index % 23 === 0) {
                    doc.autoTableAddPage();
                    doc = new jsPDF((this.depense.length) > 23 ? 'l' : 'p', 'in', [(3 + heightdoc), 8.25]) as jsPDFWithPlugin;
                  }
                }
              });

              const pageCount3 = doc.internal.getNumberOfPages();
              const pageSize3 = doc.internal.pageSize;
              // const pageHeight3 = pageSize.height ? pageSize.height : pageSize.getHeight();
              this.pageheight = doc.autoTableEndPosY() + 1.01;
              const pageHeights3 = doc.autoTableEndPosY() + 1;

              doc.setFontSize(11);
              doc.text('TOTAL DEPENSE: ' + (totaldepense / this.depense.length) + ' FCFA', 2, (pageHeights3 - 0.7), {align: 'center'});

          }
            const pageHeights3 = doc.autoTableEndPosY() + 1;
            doc.setFontSize(10);
            doc.text('Visa de l\'Agent', 2, (pageHeights3 - 0.5), {align: 'center'});
            doc.text(this.name, 2, (pageHeights3 - 0.2), {align: 'center'});
            doc.text('Visa du Chef', 4.2, (pageHeights3 - 0.5), {align: 'center'});

            // console.log(pageHeights3);
            // doc.save('table.pdf');

            doc.autoPrint();
            // This is a key for printing
            doc.output('dataurlnewwindow');
        // end print
        }); // end depense
       }); // end recette
      }); // end bagage
    }); // end colis
    setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('section');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      this.router.navigateByUrl('login');
      localStorage.removeItem('session');
      localStorage.removeItem('voyage');
      }, 700);
  }

  async getlogo(): Promise<any> {
    // Use image cache service for non-blocking, cached image loading
    this.imageCacheService
      .getImage('../../../../assets/images/logogen.jpg')
      .subscribe({
        next: (base64: string) => {
          this.base64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading logo:', error);
        }
      });
  }

  async getsessioninfo(session: any): Promise<any> {
    await this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
      // console.log('session ', this.sessiondetail);
    });
  }

  async getsessioninfoBeforeCloseSession(session: any): Promise<any> {
    await this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
      // console.log('session ', this.sessiondetail);
      setTimeout(() => {
        if(localStorage.getItem('section') == 'envoi'){
          this.getCollisSessionSummary(session);
        }
        if(localStorage.getItem('section') == 'guichet'){
          this.getpassagerSessionSummary(session);
        }
        if(localStorage.getItem('section') != 'guichet' && localStorage.getItem('section') != 'envoi'){
          setTimeout(() => {
            localStorage.removeItem('userinfo');
            localStorage.removeItem('token');
            localStorage.removeItem('loggedInUser');
            localStorage.removeItem('userRole');
            localStorage.removeItem('agenceinso');
            localStorage.removeItem('agence');
            localStorage.removeItem('authority');
            localStorage.removeItem('section');
            localStorage.removeItem('lastprint');
            localStorage.removeItem('voyage');
            this.router.navigateByUrl('login');
            localStorage.removeItem('session');
            localStorage.clear();
            }, 700);
        }
      }, 500);
    });
  }

  getpassagerSessionSummary(session: any): any {
    this.voyageservice
      .getsessionSummaryDetails(session)
      .subscribe((response: any) => {
        let doc: any;
        doc = new jsPDF("l", "in", [3, 3.5], true) as jsPDFWithPlugin;

        const contentticket: any = [];
        let totalpercu = 0;
        for (let i = 0; i < response.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < response.length; index++) {
            rowdata.push(i + 1, response[i][0], response[i][2], response[i][1]);
            totalpercu = Number(totalpercu) + Number(response[i][1]);
          }
          contentticket.push(rowdata);
        }

        doc.setFontSize(10);
        doc.setFont("Arial", "bold");
        doc.text("GENERAL EXPRESS VOYAGES", 0.9, 0.2);
        doc.setFontSize(8);
        doc.text("RAPPORT DE FIN DE SESSION", 1.1, 0.35);




        doc.setFontSize(7);
        doc.text(
          "Date d'impression:  " +
            this.datepipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
          .7,
          0.55
        );
        doc.text("Date D\'Ouverture S/N: " + this.sessiondetail?.creationDate, 0.7, 0.65);
        doc.text("Date De Fermeture S/N: "+ this.sessiondetail?.closingDate, 0.7, 0.75);
        doc.text("Agent: "+ this.name, 0.7, 0.85);

        // doc.text(
        //   "Total: "+ totalpercu / response.length + ' FCFA',
        //   0.2,
        //   2.1
        // );
        doc.text( "Visa " , 1.5,2.8
        );


        const base64Img = this.base64;

        if (base64Img) {
          doc.addImage(this.base64, "JPEG", 0.05, 0.08, 0.5, 0.6, "", "FAST");
        }

        doc.setFont("Arial", "bold");

        doc.autoTable({
          head: [["N°", "Tarif", "Passager", "Total"]],
          body: contentticket,

          showHead: "firstPage",

          startY: 1,

          pageBreak: "avoid",
          rowPageBreak: "avoid",
          theme: 'plain',
          headStyles: {
            fontSize: 9,
            fillColor: "#ffffff",
            fontStyle: "bold",
            font: "Arial",
            halign: "center",
            lineWidth: 0.01,
            lineColor: "#000000",
          },
          styles: {
            overflow: "ellipsize",
            fontSize: 8,
            font: "Arial",
            lineWidth: 0.01,
            halign: "center",
            lineColor: "#000000",
            textColor: "#000000",
          },
          columnStyles: {
            0: { overflow: "ellipsize", columnWidth: .4 },
            1: { overflow: "ellipsize", columnWidth: 0.7 },
            2: { overflow: "ellipsize", columnWidth: 0.7 },
            3: { overflow: "ellipsize", columnWidth: 0.7 },
          },

          didDrawPage: (data: any) => {

            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
          },
        });

        const pageHeights3 = doc.lastAutoTable.finalY + 1;
        doc.setFontSize(11);
        doc.text( "Total: "+ totalpercu/response.length + ' FCFA', 2, (pageHeights3 - 0.7), {align: 'center'});

        doc.output("dataurlnewwindow");
      });
      setTimeout(() => {
        // this.print(session);
        localStorage.removeItem('userinfo');
        localStorage.removeItem('token');
        localStorage.removeItem('loggedInUser');
        localStorage.removeItem('userRole');
        localStorage.removeItem('agenceinso');
        localStorage.removeItem('agence');
        localStorage.removeItem('authority');
        localStorage.removeItem('lastprint');
        localStorage.removeItem('section');
        this.router.navigateByUrl('login');
        localStorage.removeItem('session');
        localStorage.removeItem('voyage');
        localStorage.clear();
        }, 700);
  }

  getCollisSessionSummary(session: any): any {
    // console.log(session);
    this.collisservice
      .getColisSummarySession(session)
      .subscribe((response: any) => {
        // console.log("response ",response);
        let doc: any;
        doc = new jsPDF("l", "in", [6, 8.5], true) as jsPDFWithPlugin;

        const contentticket: any = [];
        let totalpercu = 0;

        this.bagageservice.getbagagesummary(session).subscribe((bagages: any) => {


        for (let i = 0; i < response.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < response.length; index++) {
            rowdata.push(i + 1, response[i][0], response[i][2], response[i][1]);
            totalpercu = Number(totalpercu) + Number(response[i][1]);
          }
          contentticket.push(rowdata);
        }

        const contentbagage: any = [];
        let totalbagage = 0;

        for (let i = 0; i < bagages.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < bagages.length; index++) {
            rowdata.push(i + 1, bagages[i][0], bagages[i][2], bagages[i][1]);
            totalbagage = Number(totalbagage) + Number(bagages[i][1]);
          }
          contentbagage.push(rowdata);
        }

        this.recetteservice.getrecettesummary(session,"autres recette").subscribe((recette: any) => {

        const contentrecette: any = [];
        let totalrecette = 0;

        for (let i = 0; i < recette.length; i++) {
          const rowdata = [];
          // console.log('Content', data[i]);
          for (let index = 0; index < recette.length; index++) {
            rowdata.push(i + 1, recette[i][0], recette[i][2], recette[i][1]);
            totalrecette = Number(totalrecette) + Number(recette[i][1]);
          }
          contentrecette.push(rowdata);
        }

        this.recetteservice.getrecettesummary(session,"autres depenses").subscribe((depense: any) => {

          const contentdepense: any = [];
          let totaldepense = 0;

          for (let i = 0; i < depense.length; i++) {
            const rowdata = [];
            // console.log('Content', data[i]);
            for (let index = 0; index < depense.length; index++) {
              rowdata.push(i + 1, depense[i][0], depense[i][2], depense[i][1]);
              totaldepense = Number(totaldepense) + Number(depense[i][1]);
            }
            contentdepense.push(rowdata);
          }

         doc.setFontSize(13);
                    doc.setFont("Arial", "bold");
                    doc.text("GENERAL EXPRESS VOYAGES", 2.5, 0.27);
                    // doc.text('GENERAL EXPRESS VOYAGES', data.settings.margin.left, 22);
                    doc.setFontSize(11);
                    doc.text("RAPPORT DE FIN DE SESSION" ,2.7, 0.5 );
                    doc.setFontSize(9);
                    doc.text("Agent:  " + this.name, 1.5, 0.65);
                    doc.text("S/N:  " +
                    this.sessiondetail.idsessiion +
                    "  N° " +
                    this.sessiondetail.sessionCount,
                    1.5, 0.83);
                    doc.text(
                      "Montant Total:  " + this.sessiondetail.sessionAmount + " FCFA",
                      1.5,
                      1
                    );
                    doc.text(
                      "Date d\'impression:  " +
                        this.datepipe.transform(
                          new Date(),
                          "dd-MM-yyyy HH:mm:ss"
                        ),
                        5,
                      0.65
                    );
                    doc.text(
                      "Date D\'Ouverture S/N:  " +
                        this.datepipe.transform(
                          this.sessiondetail.creationDate,
                          "dd-MM-yyyy HH:mm:ss"
                        ),
                      5,
                      0.83
                    );
                    doc.text(
                      "Date De Fermeture S/N:  " +
                        this.datepipe.transform(
                          this.sessiondetail.closingDate,
                          "dd-MM-yyyy HH:mm:ss"
                        ),
                        5,
                      1
                    );

                    // doc.text('Motoboy:  ' + this.bordereauinfo.motoboy.nommb, 5, 0.72);

                    const base64Img = this.base64;

                    if (base64Img) {
                      doc.addImage(this.base64, "JPEG", 0.1, 0, 1, 1);
                    }

        doc.setFont("Arial", "bold");
        doc.text("COLIS" ,1.5, 1.3 );


        doc.autoTable({
          head: [["N°", "Tarif", "Colis", "Total"]],

          body: contentticket,

          showHead: "firstPage",

          startY: 1.4,

          theme: 'plain',
          horizontalPageBreak: false,
          avoidPageSplit: true,
          pageBreak: "auto",
          rowPageBreak: "auto",
          headStyles: {
            fontSize: 9,
            fillColor: "#ffffff",
            fontStyle: "bold",
            font: "Arial",
            halign: "center",
            lineWidth: 0.01,
            lineColor: "#000000",
          },
          styles: {
            overflow: "ellipsize",
            fontSize: 8,
            font: "Arial",
            lineWidth: 0.01,
            halign: "center",
            lineColor: "#000000",
            textColor: "#000000",
          },


          didDrawPage: (data: any) => {

            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
          },
        });
        const pageHeights1 = doc.lastAutoTable.finalY + 1;
        doc.setFontSize(11);
        doc.text( "Total Colis: "+ totalpercu/response.length + ' FCFA', 5.5, (pageHeights1 - 0.7), {align: 'center'});

        if(bagages.length > 0){
          doc.text("BAGAGE" ,1.5, (pageHeights1 - 0.5));

        doc.autoTable({
          head: [["N°", "Tarif", "Bagage", "Total"]],

          body: contentbagage,

          showHead: "firstPage",

          startY: (pageHeights1 - 0.4),

          pageBreak: "auto",
          theme: 'plain',
          rowPageBreak: "auto",
          headStyles: {
            fontSize: 9,
            fillColor: "#ffffff",
            fontStyle: "bold",
            font: "Arial",
            halign: "center",
            lineWidth: 0.01,
            lineColor: "#000000",
          },
          styles: {
            overflow: "ellipsize",
            fontSize: 8,
            font: "Arial",
            lineWidth: 0.01,
            halign: "center",
            lineColor: "#000000",
            textColor: "#000000",
          },
          didDrawPage: (data: any) => {

            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
          },
        });

        this.pageHeights2 = doc.lastAutoTable.finalY + 1;
      doc.setFontSize(11);
      doc.text( "Total Bagage: "+ totalbagage/bagages.length + ' FCFA', 5.5, (this.pageHeights2 - 0.7), {align: 'center'});
        }

    if(recette.length > 0){

      doc.text("AUTRE RECETTE" ,1.5, (this.pageHeights2 - 0.5) );

      doc.autoTable({
        head: [["N°", "Tarif", "Autre Recette", "Total"]],

        body: contentrecette,

        showHead: "firstPage",

        startY: (this.pageHeights2 - 0.4) ,

        pageBreak: "auto",
        theme: 'plain',
        rowPageBreak: "auto",
        headStyles: {
          fontSize: 9,
          fillColor: "#ffffff",
          fontStyle: "bold",
          font: "Arial",
          halign: "center",
          lineWidth: 0.01,
          lineColor: "#000000",
        },
        styles: {
          overflow: "ellipsize",
          fontSize: 8,
          font: "Arial",
          lineWidth: 0.01,
          halign: "center",
          lineColor: "#000000",
          textColor: "#000000",
        },
        didDrawPage: (data: any) => {

          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
        },
      });

      this.pageHeights3 = doc.lastAutoTable.finalY + 1;
    doc.setFontSize(11);
    doc.text( "Total Autre Recette: "+ totalrecette/recette.length + ' FCFA', 5.5, (this.pageHeights3 - 0.7), {align: 'center'});
    }

    if(depense.length > 0) {
      doc.text("DEPENSE" ,1.5, (this.pageHeights3 - 0.5) );

      doc.autoTable({
        head: [["N°", "Tarif", "D\épense", "Total"]],

        body: contentdepense,

        showHead: "firstPage",

        startY: (this.pageHeights3 - 0.4) ,

        pageBreak: "auto",
        theme: 'plain',
        rowPageBreak: "auto",
        headStyles: {
          fontSize: 9,
          fillColor: "#ffffff",
          fontStyle: "bold",
          font: "Arial",
          halign: "center",
          lineWidth: 0.01,
          lineColor: "#000000",
        },
        styles: {
          overflow: "ellipsize",
          fontSize: 8,
          font: "Arial",
          lineWidth: 0.01,
          halign: "center",
          lineColor: "#000000",
          textColor: "#000000",
        },
        didDrawPage: (data: any) => {

          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
        },
      });

      const pageHeights4 = doc.lastAutoTable.finalY + 1;
    doc.setFontSize(11);
    doc.text( "Total D\épense: "+ totaldepense/depense.length + ' FCFA', 5.5, (pageHeights4 - 0.7), {align: 'center'});
    }

    const pageHeights3 = doc.autoTableEndPosY() + 1;
    doc.text( "Montant Total: "+ ((totalpercu/response.length) + (totalbagage/bagages.length > 0?(totalbagage/bagages.length):0) + (totalrecette/recette.length>0?(totalrecette/recette.length):0) + (totaldepense/depense.length >0?(totaldepense/depense.length):0 )) + ' FCFA', 2, (pageHeights3 - 0.55), {align: 'center'});
            doc.setFontSize(11);
            doc.text('Visa de l\'Agent', 2, (pageHeights3 - 0.35), {align: 'center'});
            doc.text(this.name, 2, (pageHeights3 - 0.2), {align: 'center'});
            doc.text('Visa du Chef', 4.2, (pageHeights3 - 0.35), {align: 'center'});

        doc.output("dataurlnewwindow");
      });//depense end
      });//recette end
      });//bagage end
    });//colis end

    setTimeout(() => {
      // this.print(session);
      localStorage.removeItem('userinfo');
      localStorage.removeItem('token');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userRole');
      localStorage.removeItem('agenceinso');
      localStorage.removeItem('agence');
      localStorage.removeItem('authority');
      localStorage.removeItem('lastprint');
      localStorage.removeItem('section');
      localStorage.removeItem('voyage');
      this.router.navigateByUrl('login');
      localStorage.removeItem('session');
      localStorage.clear();
      }, 700);
  }

}
